// src/routes/agent.tsx
// /agent — canvas-only agent surface (mode param removed in canvas-only cleanup).
// ?q= — optional seed prompt: navigating from the dashboard AI bar auto-sends
// the question on arrival. Consumed once then stripped from the URL by AgentPage.
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/agent')({
  validateSearch: (search: Record<string, unknown>) => ({
    q: typeof search.q === 'string' ? search.q : undefined,
  }),
})
